<template>
  <div class="mult-select">
    <div class="dp-trigger" @click="showAddressPicker" v-if="rntValue.key">{{ rntValue.value }}</div>
    <div class="dp-trigger placeholder" @click="showAddressPicker" v-else>{{ placeholder }}</div>
  </div>
</template>
<script>
export default {
  name: "SelectCity",
  props: {
    background: {
      type: String,
      default: "transparent"
    },
    placeholder: {
      type: String,
      default: "选择城市"
    },
    title: {
      type: String,
      default: "选择城市"
    },
    defaultPid: {
      type: Array,
      default: []
    },
    all: {
      type: Boolean,
      default: true
    },
    value: {
      // 必须要使用value
      type: Array,
      default: []
    }
  },
  data() {
    return {
      provinceList: [], //省列表
      cityList: [], //市列表
      addressData: [],
      rntValue: {
        value: "",
        key: ""
      },
      isShow: false
    };
  },
  mounted() {
    this.getProvinceCityList().then(newProvinceList => {
      this.addressPicker = this.$createCascadePicker({
        title: "选择城市",
        data: this.provinceList,
        alias: {
          value: "id",
          text: "name"
        },
        visible: this.isShow,
        onSelect: this.selectHandle,
        onCancel: () => {
          this.isShow = false;
        }
      });
      // console.log(this.defaultPid);
      //如果存在默认选中城市参数，数据获取PID所在索引，setData方法设置默认值
      if (this.value.length != 0) {
        //便利省级城市列表
        this.provinceList.forEach((item, index) => {
          // 获取对应ID的城市对象
          if (item.id == this.value[0]) {
            // 遍历市级对象
            item.children.forEach((sonItem, sonIndex) => {
              if (sonItem.id == this.value[1]) {
                // selectHandle方式接受id数组和name数组
                this.selectHandle(
                  [item.id, sonItem.id],
                  ["", ""],
                  [item.name, sonItem.name]
                );
                // setData用来设置主键默认显示的省市名字，接收数组对象索引值
                this.addressPicker.setData(this.provinceList, [
                  index,
                  sonIndex
                ]);
              }
            });
          }
        });
      }
    });
  },
  methods: {
    showAddressPicker() {
      this.isShow = true;
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.isShow = false;
      this.rntValue.value = `${selectedText.join(" ")}`;
      this.rntValue.key = `${selectedVal.join(",")}`;
      this.$emit("input", this.rntValue.key.split(',') );
      this.$emit("change", this.rntValue.key.split(',') );
    },
    // cancelHandle() {

    // },
    //取消确认按钮和取消按钮 change事件传值
    //     changeHandle(listIndex, itemIndex) {
    //   console.log(listIndex, itemIndex);
    //   let changeValue = [],
    //   changeItem=[],
    //     changeKey = [];
    //   if (listIndex == 0) {
    //     changeItem = this.provinceList.find((value, index) => index >= itemIndex);
    //     // let one = this.provinceList.filter((value,index)=>{
    //     //   if(itemIndex == index){return value}
    //     // })
    //     // console.log(one);
    //     // changeValue = [one.]
    //     // this.rntValue.value = [changeItem.name,changeItem.children[0].name]
    //     this.rntValue.value = [changeItem.name,changeItem.children[0].name]
    //     this.rntValue.key = [changeItem.id,changeItem.children[0].id]
    //     // this.rntValue.value = `${selectedText.join(" ")}`;
    //     // this.rntValue.key = `${selectedVal.join(",")}`;
    //   }
    // },
    async getProvinceCityList() {
      const City = await this.$http.get("/mobile/districts/public/list", {
        deep: 1
      });
      const Province = await this.$http.get("/mobile/districts/public/list", {
        deep: 0
      });
      // this.all == "all" ? this.provinceList : this.provinceList.slice(1),
      this.cityList = City.rows;
      this.provinceList = this.all ? Province.rows : Province.rows.slice(1);
      this.provinceList.forEach(province => {
        let provinceChildren = this.cityList.filter((value, index) => {
          if (value.pid == province.id) {
            return value;
          }
        });
        province.children = provinceChildren;
      });
      //   resolve(this.provinceList)
      return this.provinceList;
    }
  },
  watch: {
    isShow(e) {
      e == true ? this.addressPicker.show() : "";
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.mult-select {
  .dp-trigger {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.placeholder {
      color: #ccc;
      font-size: 14px;
    }
  }

  .slide-header {
    padding: 0 20px;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #ECECEC;
  }

  .dp-item-list {
    .dp-item {
      padding: 8px 0;
      margin: 0 15px;
      border-bottom: 1px solid #ECECEC;
      flex(row, ceter, space-between);
      font-size: 12px;

      .text {
        font-weight: bold;
        height: 22px;
        line-height: 22px;
        color: #333;
      }

      .check {
        font-size: 12px;
        color: #F10215;
      }
    }
  }
}
</style>